<template>
  <div class="logo-configure">
    <main>

      <a-row style="padding:0 20px;">
        <a-form-model :model="sysSetForm" ref="sysSetForm"  style="margin-top: 15px">
          <a-col :span="24">

            <a-form-model-item label="Logo设置" class="logo-item">
              <a-upload
                  name="avatar"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :show-upload-list="false"
                  :before-upload="beforeUpload"
              >
                <div v-if="uploadShow">

                   <img  class="imgSize"  v-if="imgShow" :src="this.imageUrl " alt="avatar" />

                   <img  class="imgSize"  v-else :src="this.axios.defaults.baseURL + '/setting/getLogo' " alt="avatar" />

                </div>


                <div v-else>
                  <a-icon type="plus" />
                </div>
              </a-upload>
              <span class="tips-textColor">( 图片大小限定为 200x60px,格式限定为png\jpg,大小不超过1M )</span>
            </a-form-model-item>

          </a-col>

          <a-col :span="24" class="sysSet-operate">
            <a-form-model-item >
              <a-button type="primary"  @click="fileSubmit" :loading="submitLoad" style="color: #ffffff">
                保存
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-form-model>
      </a-row>


    </main>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      loading: false,
      imageUrl:  '',
      sysSetForm:{
        file:"",
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      // 文件上传
      completeFileList: [],
      previewVisible: false,
      imgShow:false,
      uploadShow:false
    };
  },
  methods: {
    // 录屏清理
    screencapClear(){
      this.axios
          .post("/setting/cleanScreenRecord", )
          .then((res) => {
            // console.log(res.data);
            if (res.code === 200) {
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },

    // 录屏清理
    onChange(val){
      console.log(val)
    },

    // 保存
    fileSubmit(){
      this.$refs.sysSetForm.validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          let formData = new FormData();
          let saveData = this.$lodash.cloneDeep(this.sysSetForm);

          for (let i in saveData) {
            if ( saveData[i] == null || saveData[i] == undefined) {
              saveData[i]  = ''
            }
            formData.append(i, saveData[i])
          }
          formData.delete('file')
          for (let f in saveData.file) {
            formData.append('file', saveData.file[f])
          }

          this.axios
              .post('setting/uploadLogo',  formData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  this.$message.success(res.message);
                }if (res.code === 400) {
                  this.$message.warning(res.message);
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    beforeUpload(file) {
      if (!(file.type === 'image/jpeg' || file.type === 'image/png' )) {
        this.$message.warning('文件格式错误,请重新上传');

        return false
      }else if(file.size / 1024 / 1024 > 1) {
        this.$message.warning('文件大小超过'+'1M  '+'请重新上传图像');
        return false
      }
      this.sysSetForm.file = [...[], file];

      getBase64(file, imageUrl => {
        this.imageUrl = imageUrl ;
      });
      this.imgShow = true
      return false;
    },
  },
  beforeMount(){
    this.axios
        .get("/setting/getLogo", )
        .then((res) => {
            this.imageUrl = res
            this.uploadShow = true
        })
        .catch((err) => {
          console.log(err);
        });
  },
};
</script>

<style lang="scss" scoped>
.logo-configure {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;


    ::v-deep .ant-form-item-label{
      font-weight: 600;
    }
    .ant-form-item label{
      font-weight: 600;
    }
    .logo-item{
      ::v-deep .ant-upload.ant-upload-select-picture-card{
        width: 200px;
        height: 60px;
      }
      ::v-deep .ant-form-item-children{
        width: 100%;
        display: flex;
        align-items: flex-end;
        margin-top: 5px;
        .imgSize{
          width: 184px;
          height: 60px;
          object-fit: contain;
        }
      }
      ::v-deep .ant-upload-picture-card-wrapper{
        width: 13%;
      }
      .tips-textColor{
        color: #d1d1d1;
        height: 35px;
      }
    }

    //按钮
    .sysSet-operate{
      text-align: right;
      margin-top: 385px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }

  }
}
</style>
